import styled from "styled-components";

export const Header = styled.div`
  margin-top: 8px;
`

export const HeaderTitle = styled.h3`
`
